<script>
  import Button from "./Button.svelte"
</script>

<Button {...$$restProps} type="submit" />
